import { MAX_RECORD_REASON_LENGTH, MIN_RECORD_REASON_LENGTH } from '@felix/domain';
import { z } from 'zod';
import { DRAFT_NOTE_MAX, DRAFT_TITLE_MAX } from './record-model.js';

/**
 * Kayıt ekranlarının form şemaları (React Hook Form + Zod; CLAUDE.md "Form ve doğrulama"). Hata
 * iletileri `forms.errors.<kod>` anahtarıdır; sunucu aynı kuralları yeniden denetler (ADR 0042
 * §13: gerekçe 5–2000 karakter).
 */

/** Gerekçe (değişiklik, değişmeden yeniden gönderim, iptal, vazgeçme, kâğıt istisnası). */
export const recordReason = z
  .string()
  .trim()
  .min(MIN_RECORD_REASON_LENGTH, 'REASON_REQUIRED')
  .max(MAX_RECORD_REASON_LENGTH, 'REASON_TOO_LONG');

export const draftSchema = z.object({
  title: z.string().trim().max(DRAFT_TITLE_MAX, 'VALIDATION_FAILED'),
  note: z.string().trim().max(DRAFT_NOTE_MAX, 'VALIDATION_FAILED'),
});
export type DraftValues = z.infer<typeof draftSchema>;

export const reasonSchema = z.object({ reason: recordReason });
export type ReasonValues = z.infer<typeof reasonSchema>;

/** Değişiklik (Amend): gerekçe zorunlu, not serbest (§13). */
export const amendSchema = z.object({
  reason: recordReason,
  note: z.string().trim().max(DRAFT_NOTE_MAX, 'VALIDATION_FAILED'),
});
export type AmendValues = z.infer<typeof amendSchema>;

/**
 * New record (§3): yürürlükteki revizyon ya da kâğıt istisnası. İstisnada eski revizyon ve
 * gerekçe zorunlu [sorular #228]; yürürlükteki revizyonda gerekçe verilmez (Ek U7).
 */
export const newRecordSchema = z
  .object({
    revisionId: z.string(),
    current: z.boolean(),
    title: z.string().trim().max(DRAFT_TITLE_MAX, 'VALIDATION_FAILED'),
    paperReason: z.string().trim().max(MAX_RECORD_REASON_LENGTH, 'REASON_TOO_LONG'),
  })
  .superRefine((value, ctx) => {
    if (!value.current && value.paperReason.length < MIN_RECORD_REASON_LENGTH) {
      ctx.addIssue({ code: 'custom', path: ['paperReason'], message: 'REASON_REQUIRED' });
    }
  });
export type NewRecordValues = z.infer<typeof newRecordSchema>;
